import Email from "../components/email/email";
import Vistor from "../components/visitor/vistor";
import States from "../components/states/states";
import Marketing from "../components/marketing/marketing";
import Static from "../components/static/static";
import Progress from "../components/progress/progress";

function Analytics(){
    return(
        <>
        <Email/>
        <Vistor/>
        <States/>
 <Marketing/>
        <Static/>
        <Progress/>  

              </>
    )
}
export default Analytics